// Pick bilingual field from object {en, gr}
export function pickLang(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || obj.gr || "";
}

export const TRANSLATIONS = {
  nav: {
    home:      { en: "Home",       gr: "Αρχική" },
    about:     { en: "About",      gr: "Σχετικά" },
    services:  { en: "Services",   gr: "Υπηρεσίες" },
    products:  { en: "Products",   gr: "Προϊόντα" },
    portfolio: { en: "Portfolio",  gr: "Έργα" },
    blog:      { en: "Blog",       gr: "Blog" },
    vlogs:     { en: "Vlogs",      gr: "Vlogs" },
    booking:   { en: "Book",       gr: "Κράτηση" },
    contact:   { en: "Contact",    gr: "Επικοινωνία" },
    quote:     { en: "Quote",      gr: "Προσφορά" },
  },
  cta: {
    request_quote: { en: "Request Quote",      gr: "Αίτηση Προσφοράς" },
    book_now:      { en: "Book Now",            gr: "Κράτηση Τώρα" },
    explore:       { en: "Explore Products",   gr: "Δείτε Προϊόντα" },
    learn_more:    { en: "Learn More",          gr: "Μάθετε Περισσότερα" },
    add_to_quote:  { en: "Add to Quote",        gr: "Προσθήκη σε Προσφορά" },
    view_all:      { en: "View All",            gr: "Όλα" },
    send:          { en: "Send Message",        gr: "Αποστολή" },
    submit_quote:  { en: "Submit Quote Request",gr: "Υποβολή Προσφοράς" },
    confirm_book:  { en: "Confirm Booking",     gr: "Επιβεβαίωση" },
    subscribe:     { en: "Subscribe",           gr: "Εγγραφή" },
    in_cart:       { en: "In your quote cart",  gr: "Στο καλάθι προσφοράς" },
    remove:        { en: "Remove",              gr: "Αφαίρεση" },
  },
  hero: {
    eyebrow: { en: "Cyprus // Pro Audio + Lighting", gr: "Κύπρος // Επαγγελματικός Ήχος" },
    title1:  { en: "WE BUILD",     gr: "ΧΤΙΖΟΥΜΕ" },
    title2:  { en: "THE NIGHT.",   gr: "ΤΗ ΝΥΧΤΑ." },
    sub:     {
      en: "Sound systems, lighting rigs, lasers, CCTV & security, repairs and turn-key venue installs. From after-dark clubs to open-air festivals — we make it loud, we make it look unreal, and we keep it secure.",
      gr: "Ηχητικά συστήματα, φωτισμός, lasers, CCTV & ασφάλεια, επισκευές και ολοκληρωμένες εγκαταστάσεις χώρων.",
    },
  },
  sections: {
    services_eyebrow: { en: "What we do",   gr: "Τι κάνουμε" },
    products_eyebrow: { en: "Our gear",     gr: "Ο εξοπλισμός μας" },
    portfolio_eyebrow:{ en: "Past projects",gr: "Έργα μας" },
    blog_eyebrow:     { en: "Journal",      gr: "Blog" },
    contact_eyebrow:  { en: "Get in touch", gr: "Επικοινωνία" },
    about_eyebrow:    { en: "About us",     gr: "Σχετικά με εμάς" },
    booking_eyebrow:  { en: "Schedule",     gr: "Πρόγραμμα" },
  },
  forms: {
    name:     { en: "Full name",     gr: "Ονοματεπώνυμο" },
    email:    { en: "Email",         gr: "Email" },
    phone:    { en: "Phone",         gr: "Τηλέφωνο" },
    company:  { en: "Company",       gr: "Εταιρεία" },
    subject:  { en: "Subject",       gr: "Θέμα" },
    message:  { en: "Tell us about your event or question", gr: "Πείτε μας για την εκδήλωσή σας" },
    date:     { en: "Event date",    gr: "Ημερομηνία" },
    time:     { en: "Time",          gr: "Ώρα" },
    location: { en: "Location / Venue", gr: "Τοποθεσία" },
    service:  { en: "Service",       gr: "Υπηρεσία" },
    notes:    { en: "Notes",         gr: "Σημειώσεις" },
  },
  cart: {
    title:  { en: "Your Quote Basket", gr: "Καλάθι Προσφοράς" },
    empty:  { en: "No items yet — browse products and tap Add to Quote.", gr: "Άδειο καλάθι — προσθέστε προϊόντα." },
    qty:    { en: "Qty", gr: "Ποσ." },
  },
  categories: {
    all:         { en: "All",         gr: "Όλα" },
    speakers:    { en: "Speakers",    gr: "Ηχεία" },
    amplifiers:  { en: "Amplifiers",  gr: "Ενισχυτές" },
    mixers:      { en: "Mixers / DJ", gr: "Μίκτες / DJ" },
    microphones: { en: "Microphones", gr: "Μικρόφωνα" },
    lighting:    { en: "Lighting",    gr: "Φωτισμός" },
    stage:       { en: "Stage / Truss",gr: "Σκηνή / Truss" },
    video:       { en: "Video / LED Screens", gr: "Video / Οθόνες LED" },
    cctv:        { en: "CCTV / Security", gr: "CCTV / Ασφάλεια" },
  },
  footer: {
    tagline: { en: "Sound. Light. Built for the night.", gr: "Ήχος. Φως. Φτιαγμένα για τη νύχτα." },
    newsletter_title: { en: "Get the dispatch", gr: "Newsletter" },
    newsletter_sub: { en: "Gear drops, behind-the-scenes builds, no spam.", gr: "Νέα προϊόντα και έργα. Χωρίς spam." },
    rights: { en: "All rights reserved.", gr: "Με την επιφύλαξη παντός δικαιώματος." },
  }
};

export const t = (key, lang) => {
  const parts = key.split(".");
  let cur = TRANSLATIONS;
  for (const p of parts) cur = cur?.[p];
  return pickLang(cur, lang);
};
